import { useCookieConsent } from '@packages/utilities';
import { useEffect, useMemo } from 'react';
import { useTracking } from '@packages/tracking';

export const Zoovu = ({ advisorId, zoovuURL }: { advisorId?: string; zoovuURL?: string }) => {
  const isZoovuAllowed: boolean = useCookieConsent('C0002');
  const dispatchGTMEvent = useTracking();
  const eventValue = useMemo(
    () => (advisorId ? { zoovuAdvisorId: advisorId } : { zoovuURL }),
    [advisorId, zoovuURL],
  );

  useEffect(() => {
    if (isZoovuAllowed) {
      dispatchGTMEvent({
        event: advisorId ? 'renderZoovuScript' : 'renderZoovuScriptURL',
        eventValue,
      });
    }
  }, [advisorId, dispatchGTMEvent, eventValue, isZoovuAllowed]);

  return <div id="zoovu-assistant" data-scroll-behavior="noscroll" />;
};
